export default __webpack_public_path__ + "static/media/alexandru_nistor.b806c6ba.png";